<script>

export default {
  name: 'building-switcher',
  data() {
    return {
      selected: null,
      buildings: null,
      floors: null,
      selected_floor: null,
      rooms: null,
      selected_room: null
    };
  },
  computed: {
    activeBuilding() {
      const buildingId = parseInt(this.$route.params.id, 10);
      return this.buildings.find(b => b.id === buildingId) || this.buildings[0];
    },
    activeFloor() {
      const floorId = parseInt(this.$route.params.floor_id, 10) || 'all';
      return this.floors.find(b => b.id === floorId);
    },
    activeRoom() {
      const roomId = parseInt(this.$route.params.room_id, 10) || 'all';
      return this.rooms.find(b => b.id === roomId);
    },
  },
  mounted() {
    this.$http.get('/buildings').then((response) => {
      this.buildings = response.data;
      const current = this.buildings.find(i => i.id === this.$route.params.id);
      this.selected = (current || this.buildings[0]);
      this.getFloors(this.selected.id);
    });
  },
  methods: {
    getFloors(id) {
      this.$http.get(`/buildings/${id}/floors/`).then((response) => {
        this.floors = [{ name: 'Alle', id: 'all' }].concat(response.data);
        const current = this.floors.find(i => i.id === this.$route.params.floor_id);
        this.selected_floor = (current || this.floors[0]);
      });
    },
    getRooms(id) {
      this.$http.get(`/floors/${id}/rooms/`).then((response) => {
        this.rooms = [{ name: 'Alle', id: 'all' }].concat(response.data.rooms);
        const current = this.rooms.find(i => i.id === this.$route.params.room_id);
        this.selected_room = (current || this.rooms[0]);
      });
    },
  },
  watch: {
    $route(to, _from) {
      if (to.params.id !== _from.params.id && to.params.id !== 'all') {
        this.getFloors(to.params.id);
      }
      if (to.params.floor_id !== _from.params.floor_id && to.params.floor_id !== 'all') {
        this.getRooms(to.params.floor_id);
      } else if (to.params.floor_id !== _from.params.floor_id && to.params.floor_id === 'all') {
        this.rooms = null;
      }
    },
  },
};

</script>

<template>
  <div>
  <b-dropdown v-if="buildings">
    <button class="button is-info" slot="trigger">
        <span>{{activeBuilding.name}}</span>
    </button>
    <b-dropdown-item v-for="building in buildings" :key="building.id" :has-link="true">
      <router-link class="dropdown-link"
        :to="{ name: 'building-instance', params: { id: building.id, floor_id: 'all', room_id: 'all' } }">
        {{ building.name }}
      </router-link>
    </b-dropdown-item>
  </b-dropdown>

  <b-dropdown v-if="floors">
    <button class="button is-info" slot="trigger">
      <span>{{activeFloor.name}}</span>
    </button>
    <b-dropdown-item v-for="floor in floors" :key="floor.id" :has-link="true">
      <router-link class="dropdown-link"
        :to="{ name: 'building-instance', params: { id: activeBuilding.id, floor_id: floor.id, room_id: 'all' } }">
        {{ floor.name }}
      </router-link>
    </b-dropdown-item>
  </b-dropdown>

  <b-dropdown v-if="rooms">
    <button class="button is-info" slot="trigger">
      <span>{{activeRoom.name}}</span>
    </button>
    <b-dropdown-item v-for="room in rooms" :key="room.id" :has-link="true">
      <router-link class="dropdown-link"
        :to="{ name: 'building-instance', params: { id: activeBuilding.id, floor_id: activeFloor.id, room_id: room.id } }">
        {{ room.name }}
      </router-link>
    </b-dropdown-item>
  </b-dropdown>
  </div>
</template>

<style lang="scss" scoped>
</style>

